import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoDateRangePickerMixin from './KendoDateRangePickerMixin'

export default {
    name: 'kendo-daterangepicker',
    mixins: [ KendoDateRangePickerMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render (createElement) {
        const h = gh || createElement
        return h('div')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateRangePicker/index.js